/* eslint-disable import/no-cycle */
import { createSlice } from '@reduxjs/toolkit'
import { FetchStatus } from '@flatsy/types/FetchStatus'
import { BookableSlotsState } from './Type'
import { bookableSlotsAdapter } from './Selector'
import { syncBookableSlots } from './Action'

export const initialState = bookableSlotsAdapter.getInitialState<BookableSlotsState>({
  status: FetchStatus.IDLE,
  error: null,
})

export const bookableSlotsSlice = createSlice({
  name: 'bookableSlots',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(syncBookableSlots.pending, (state) => {
        state.status = FetchStatus.LOADING
      })
      .addCase(syncBookableSlots.fulfilled, (state, action) => {
        bookableSlotsAdapter.setAll(state, action.payload)
        state.status = FetchStatus.SUCCEEDED
      })
      .addCase(syncBookableSlots.rejected, (state, action) => {
        if (action.payload?.code === 404) {
          state.status = FetchStatus.NOT_FOUND
        } else {
          state.status = FetchStatus.FAILED
        }
      })
  },
})
